import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import MovePanel from './MovePanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MovesWidget',
    props: {
        moves: {},
        lite: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_slide_group = _resolveComponent("v-slide-group");
            return (_openBlock(), _createBlock(_component_v_slide_group, { class: "smoothScrollContainer" }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moves, (move) => {
                        return (_openBlock(), _createBlock(MovePanel, {
                            class: "smoothScrollPanel",
                            key: move.id,
                            move: move.move,
                            "customer-move": move,
                            lite: _ctx.lite
                        }, null, 8, ["move", "customer-move", "lite"]));
                    }), 128))
                ]),
                _: 1
            }));
        };
    }
});
